module.exports = __webpack_public_path__ + "static/img/squirrel-cup-header.0cc97825.png";